import React from 'react';
import { Tooltip } from '@material-ui/core';

const types = {
    none: '',
    light: 'btn-light-{variant}',
    hover: 'btn-hover-{variant}',
    'hover-light': 'btn-hover-light-{variant}',
    outline: 'btn-outline-{variant}'
};

const sizes = {
    xsmall: 'xs',
    small: 'sm',
    medium: 'md',
    large: 'lg'
};

const defaultClassName = 'font-weight-bold btn btn-icon btn-circle btn-text-{variant}';

const replaceVariant = /\{variant\}/g;

export function ButtonIcon ({
    icon,
    onClick,
    type = 'hover-light',
    size = 'medium',
    title = 'Aceptar',
    variant = 'primary',
    hidden = false,
    buttonType,
    disabled = false
}) {
    const className = `${defaultClassName} btn-${(sizes[size] || '')} btn-icon-${variant} ${(types[type] || '')}`.replace(replaceVariant, variant);

    return (
        <Tooltip hidden={hidden} title={title}>
            <span>
                <button disabled={disabled} type={buttonType} className={className} onClick={onClick}>
                    {icon}
                </button>
            </span>
        </Tooltip>
    );
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    ButtonIcon.displayName = 'ButtonIcon';
}
